module.exports = __webpack_public_path__ + "static/media/crash.29a28366.wav";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jazzband/demo/samples/drummer/crash.wav
// module id = 205
// module chunks = 0